import React from 'react';
import './Box.css';
import Main from '../Main/Main';

function Box() {
    return (
        <div className="Main">
            <Main />
        </div>
    );
}

export default Box;
